
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import CardLayout from "../../components/utils/CardLayout";
import CheckStatusActions from "../../redux/checkStatus/actions";
import Modal from "../../components/utils/Modal";
import { useDispatch, useSelector } from "react-redux";
import ToastAlert from "../../components/utils/ToastAlert";
import Table from "../../components/utils/Table";
import animatedimg from '../../assets/images/200w.gif';
import QRCode from "react-qr-code";
const { checkStatus, resetMessage, checkDataUsage } = CheckStatusActions;


const CheckStatus = () => {
  const dispatch = useDispatch();
  const { checkStatusLoading, checkStatusError, checkStatusResult,
    checkDataUsageLoading,
    checkDataUsageError,
    checkDataUsageResult, } = useSelector((state) => state.checkStatus);
  const [showQRModal, setShowQRModal] = useState(false);
  const [selectedQrData, setSelectedQrData] = useState({});
  const { register, handleSubmit, reset, formState: { errors }, } = useForm({
    mode: "onChange",
    defaultValues: { iccid: "", msisdn: "", },
  });

  useEffect(() => {
    return () => {
      dispatch(resetMessage());
    };
  }, [])

  useEffect(() => {
    if (checkStatusError) {
      ToastAlert({ type: "error", text: checkStatusError });
    }

    if (checkDataUsageError) {
      ToastAlert({ type: "error", text: checkDataUsageError });
    }
  }, [checkStatusError, checkDataUsageError]);


  const onSubmit = (data) => {
    const iccid = data.iccid?.trim();
    const msisdn = data.msisdn?.trim();

    if (!iccid && !msisdn) {
      ToastAlert({
        type: "error",
        text: "At least one field is required",
      });
      return;
    }
    dispatch(resetMessage());
    dispatch(checkStatus(data))

  };
  const handleReset = () => {
    reset();
    dispatch(resetMessage());
  };

  const DetailRow = ({ label, value }) => {
    return (
      <div className="d-flex justify-content-between align-items-center gap-3 py-1 " style={{ fontSize: "14px" }}>
        <span className="text-primary  fw-semibold">
          {label}
        </span>

        <small className="text-end">
          {value || "-"}
        </small>
      </div>
    );
  };

  const handleCheckDataUsage = () => {
    const payload = {
      partnerTransactionId: "",
      msisdn: checkStatusResult?.msisdn || "",
      iccid: checkStatusResult?.iccid || "",
    }
    dispatch(checkDataUsage(payload))
  }

  const handleQRClick = (data) => {
    setSelectedQrData(data);
    setShowQRModal(true);

  };
  const handleCloseQR = () => {
    setShowQRModal(false);
    setSelectedQrData({});
  };

  const columns = [
    // { displayName: "Sr.No.", key: "key" },
    { displayName: "Category", key: "category" },
    { displayName: "Bucket Value", key: "bucketValue" },
    { displayName: "Used", key: "used" },
    { displayName: "Remaining", key: "remaining" },
    { displayName: "Subscriber Change Date", key: "subscriberStatusChangedDate" },
    { displayName: "Expiry Date Time", key: "expiryDateTime" },
    { displayName: "Current Behavior", key: "currentBehavior" },

  ];

  const dataSource = useMemo(() => {
    if (!checkDataUsageResult?.length) {
      return [];
    }

    return checkDataUsageResult.map((item, index) => ({
      // key: index + 1,
      category: item?.category ?? "-",
      bucketValue: item?.bucketValue + ' ' + item?.bucketValueUnit ?? "-",
      used: item?.used + ' ' + item?.unit ?? "-",
      remaining: item?.remaining + ' ' + item?.unit ?? "-",
      subscriberStatusChangedDate: item?.subscriberStatusChangedDate ?? "-",
      expiryDateTime: item?.expiryDateTime,
      currentBehavior: (
        <span className={`badge ${item?.currentBehavior?.toLowerCase() === "active" ? "bg-success-subtle text-success" : "bg-primary-subtle text-primary"}`} >
          {item?.currentBehavior ?? "-"}
        </span>
      ),
    }));
  }, [checkDataUsageResult]);


  return (
    <CardLayout
      title="Check Status"
      icon="fas fa-tasks" >
      <div className="row">
        {/* center Side */}
        <div className="col-lg-12">
          <form
            onSubmit={handleSubmit(onSubmit)} >
            <div className="row">
              {/*  Serial Number*/}
              <div className="col-lg-3 mb-2">
                <label className="form-label fw-semibold">
                  Serial Number
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.iccid ? "is-invalid" : ""
                    }`}
                  placeholder="Serial Number"
                  {...register("iccid", {
                    // required: "Serial Number is required",
                    validate: (value) => {
                      const val = value.trim();

                      if (val && !/^\d+$/.test(val)) {
                        return "Only numbers are allowed"
                      }
                      return true;
                    }
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, ""); // allow only numbers
                  }}
                />

                <div className="invalid-feedback"> {errors.iccid?.message} </div>
              </div>

              {/* MSISDN  */}
              <div className="col-lg-3 mb-2">
                <label className="form-label fw-semibold">
                  MSISDN
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.msisdn ? "is-invalid" : ""
                    }`}
                  placeholder="MSISDN"
                  maxLength={10}
                  {...register("msisdn", {
                    // required: "MSISDN is required",
                    validate: (value) => {
                      const val = value.trim();

                      if (val && !/^\d+$/.test(val)) {
                        return "Only numbers are allowed"
                      }
                      return true;
                    }
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, ""); // allow only numbers
                  }}
                />

                <div className="invalid-feedback"> {errors.msisdn?.message} </div>
              </div>

              {/* Submit */}
              <div className="col-md-6 col-lg-3 d-flex align-items-end mb-lg-0 mb-2" style={{ height: '70px' }}>
                <div className="d-flex gap-3">
                  <Button
                    title="Get Details"
                    buttonType="submit"
                    variant="primary"
                    loading={checkStatusLoading}
                    icon={<i className="ri-search-line me-2"></i>} />
                  <Button
                    title="Reset"
                    buttonType="button"
                    variant="secondary"
                    icon={<i className="ri-refresh-line me-2"></i>}
                    onClick={handleReset}
                    disable={checkStatusLoading}
                  />
                </div>
              </div>
            </div>
          </form>
          {checkStatusResult && Object.keys(checkStatusResult).length > 0 &&
            <div className="row g-3">

              {/* Status */}
              <div className="col-lg-4">
                <div className="card h-100 border">
                  <div className="card-header fw-semibold bg-primary">
                    Status
                  </div>

                  <div className="card-body py-1">

                    <DetailRow
                      label="Carrier Status"
                      value={checkStatusResult?.carrierStatus} />

                    <DetailRow
                      label="Carrier Subscriber Status"
                      value={checkStatusResult?.carrierSubscriberStatus} />

                    <DetailRow
                      label="Activation Date"
                      value={checkStatusResult?.activationDate} />

                  </div>
                </div>
              </div>

              {/* Subscriber Details */}
              <div className="col-lg-4">
                <div className="card h-100 border">
                  <div className="card-header fw-semibold bg-primary">
                    Subscriber Details
                  </div>

                  <div className="card-body py-1">
                    <DetailRow
                      label="Account ID"
                      value={checkStatusResult?.accountID} />

                    <DetailRow
                      label="MSISDN"
                      value={checkStatusResult?.msisdn} />

                    <DetailRow
                      label="ICCID"
                      value={checkStatusResult?.iccid} />

                    <DetailRow
                      label="Status Changed Date"
                      value={checkStatusResult?.subscriberStatusChangedDate}
                    />

                  </div>
                </div>
              </div>

              {/* Plan Information */}
              <div className="col-lg-4">
                <div className="card h-100 border">
                  <div className="card-header fw-semibold bg-primary">
                    Plan Information
                  </div>

                  <div className="card-body py-1" >

                    <DetailRow
                      label="Plan ID"
                      value={checkStatusResult?.planId}
                    />

                    <DetailRow
                      label="Plan Name"
                      value={checkStatusResult?.planName}
                    />

                    {/* <DetailRow
                      label="Billing Code"
                      value={checkStatusResult?.billingCode}
                    /> */}

                    <DetailRow
                      label="Expiration Date"
                      value={checkStatusResult?.expirationDate}
                    />

                  </div>
                </div>
              </div>

              {/* E911 Address */}
              <div className="col-lg-8">
                <div className="card border">
                  <div className="card-header fw-semibold bg-primary">
                    E911 Address
                  </div>

                  <div className="card-body py-1">
                    <div className="row py-2">

                      <div className="col-lg-3">
                        <div className="text-primary fw-5 fw-semibold"> Street </div>
                        <small className="" style={{ fontSize: "12px" }}> {checkStatusResult?.e911Address?.street1} </small>
                      </div>

                      <div className="col-lg-3">
                        <div className="text-primary fw-5 fw-semibold"> City </div>
                        <small className="" style={{ fontSize: "12px" }}> {checkStatusResult?.e911Address?.city} </small>
                      </div>
                      <div className="col-lg-3">
                        <div className="text-primary fw-5 fw-semibold"> State </div>
                        <small className="" style={{ fontSize: "12px" }}> {checkStatusResult?.e911Address?.state} </small>
                      </div>
                      <div className="col-lg-3">
                        <div className="text-primary fw-5 fw-semibold"> Zipcode </div>
                        <small className="" style={{ fontSize: "12px" }}> {checkStatusResult?.e911Address?.zip} </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* QR */}
              <div className="col-lg-4">
                <div className="card h-100 border">
                  <div className="card-header fw-semibold bg-primary">
                    QR Code
                  </div>

                  <div className="d-flex justify-content-center align-items-center">
                    {checkStatusResult?.lpaString ? <>
                      <div className="d-flex px-3">
                        <div className="text-primary fw-5 fw-semibold me-2">LPA</div>
                        <small className="px-2" style={{
                          fontSize: "12px",
                          overflowWrap: "anywhere",
                          wordBreak: "break-word",
                        }}>{checkStatusResult?.lpaString ?? ''}</small>
                      </div>
                      <div className="p-3 d-flex justify-content-center align-items-center" onClick={() => handleQRClick(checkStatusResult)} style={{ cursor: "pointer" }} >
                        {checkStatusResult?.lpaString ? <QRCode value={checkStatusResult?.lpaString} size={25} /> : ''}
                      </div>
                    </> : <div className="pt-3 fw-semibold text-primary">
                      <div>LPA is not available!</div>
                    </div>}
                  </div>
                </div>
              </div>

              {/* Check Data Usage Button */}
              {dataSource && dataSource.length > 0 ? <div className="col-lg-2">
                <div className="p-2 fw-semibold btn-secondary-light text-center border rounded-2">Active Plan(s) Usage</div>
              </div> : <div className="">
                <div
                  className={`check-data-usage-btn ${checkDataUsageLoading ? "loading" : ""
                    }`}
                  onClick={checkDataUsageLoading ? undefined : handleCheckDataUsage}
                >
                  <div className="data-usage-gif">
                    <img src={animatedimg} alt="Check Usage" />
                  </div>

                  <div className="data-usage-text">
                    <span>Check Usage</span>
                  </div>
                </div>
              </div>}

              <div className="">
                <Table
                  columns={columns}
                  loading={checkDataUsageLoading}
                  data={dataSource}
                  pagination={true}
                  tableHeight="160px"
                />
              </div>

            </div>
          }

        </div>
      </div>
      <Modal
        title={selectedQrData?.TransactionID || 'QR Code'}
        showModal={showQRModal}
        onHide={handleCloseQR}
        showFooter={false}
        width={350}
      >
        <div className="d-flex flex-column justify-content-center pb-2">
          <div
            className="mb-3"
            style={{ display: "flex", justifyContent: "center", }}
          >
            {selectedQrData?.lpaString && (<div className="shadow p-3 bg-body-tertiary rounded"><QRCode value={selectedQrData?.lpaString} size={180} /></div>)}
          </div>

          <div className="d-flex justify-content-between mb-1">
            <div className="text-primary fw-5 fw-semibold me-2" style={{ fontSize: "14px" }}>MSISDN</div>
            <small className="px-2" style={{ fontSize: "12px", overflowWrap: "anywhere", wordBreak: "break-word", }}>{selectedQrData?.msisdn ?? ''}</small>
          </div>
          <div className="d-flex mb-1 justify-content-between">
            <div className="text-primary fw-5 fw-semibold me-2" style={{ fontSize: "14px" }}>Serial Number</div>
            <small className="px-2" style={{ fontSize: "12px", overflowWrap: "anywhere", wordBreak: "break-word", }}>{selectedQrData?.iccid ?? ''}</small>
          </div>
          <div className="d-flex justify-content-between">
            <div className="text-primary fw-5 fw-semibold me-2" style={{ fontSize: "14px" }}>LPA</div>
            <small className="px-2" style={{ fontSize: "12px", overflowWrap: "anywhere", wordBreak: "break-word" }}>{selectedQrData?.lpaString ?? ''}</small>
          </div>
        </div>
      </Modal>
    </CardLayout>
  );


};

export default CheckStatus;
